const env = process.env.NODE_ENV || 'development';
const cfg = require(__dirname + '/api.json')[env];
cfg.apiUrl = process.env.API_URL || cfg.url;

// cfg.apiUrl = "https://api.mrialerts.com";  //<---- LIVE: before publishing uncomment this line
// cfg.apiUrl = "http://localhost:3001";   // <-- ONLY for testing Display, Camera, Monitor, Comments
// cfg.apiUrl = "http://localhost:3002";   // <-- ONLY for testing Auth, Profile, Brightness
// cfg.apiUrl = "http://localhost:3006";   // <-- ONLY for testing Temperature

export const config = cfg;